module.exports = __webpack_public_path__ + "static/media/support.f5559c37.JPG";